<template>
  <div>
    <div
      v-for="(item, index) in renderComponentList"
      :id="item.preId ? `${item.preId}-${item.moduleId}` : ''"
      :key="item.key"
      :class="
        [
          'component-wrapper',
          {
            'special-wraper': isSpecialWrapper(item),
            'no-margin-bottom' : !pageHasMarginBottom,
          },
          item.componentName
        ]"
      :data-idx="index"
    >
      <component
        :is="getComponent(item.componentName)"
        v-sa-track="[{type: 'visually', event: 'component_show', data: getTrackData(item)}]"
        :locale="locale"
        :module-id="item.moduleId"
        :component-name="item.componentName"
        :component-type="item.componentType"
        :component-title="item.componentTitle"
        :registration="item.registration"
        v-bind="item.componentData"
        :index="index"
        @hook:mounted="onChildMounted(item)"
        @components-loaded="onCategoryLoaded(item)"
      />
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
// 组件映射表
const componentMap = {
  // banner1
  Banner: () => import(/* webpackPrefetch: true */ './Banner/web'),
  // banner2
  Banner2: () => import(/* webpackPrefetch: true */ './Banner-2/web'),
  // 通用图片组件3
  Banner3: () => import(/* webpackPrefetch: true */ './Banner-3/web'),
  // 分类组件
  Category: () => import('./Category/web'),
  // 模拟考组件
  MockExamColumn: () => import('./MockExamColumn/web'),
  // 图文组件（一）文本样式1
  ModuleRichText: () => import('./ModuleRichText/web'),
  // 图文组件（二）文本样式2
  PageRichText: () => import('./PageRichText/web'),
  // 留资组件1
  GetNotified: () => import('./GetNotified/web'),
  // 留资组件2 留资组件
  GetNotified2: () => import('./GetNotified-2/web'),
  // 留资组件（日期配置）
  GetNotified2Date: () => import('./GetNotified-2-Date/web'),
  // 报名组件
  Application: () => import('./Application/web'),
  // 图文组件：轮播组件
  CarouselComponent: () => import('./CarouselComponent/web'),
  // 吸底组件
  suctionBottom: () => import('./SuctionBottom/web'),
  // 课程组件：课程列表组件
  CourseListComponent: () => import('./CourseListComponent/web'),
  // Inperson 课程列表组件
  InpersonCourseListComponent: () => import('./InpersonCourseListComponent/web'),
  // 资讯组件
  NewsGroup: () => import('./NewsGroup/web'),
  // 评价组件 自定义
  UserComments: () => import('./UserComments/web'),
  // 评价组件2 自定义
  UserCommentsTwo: () => import('./UserCommentsTwo/web'),
  // 家长评论组件
  ParentCommentsComponent: () => import('./ParentCommentsComponent/web'),
  // 品牌介绍
  BrandIntroduceComponent: () => import('./BrandIntroduceComponent/web'),
  // Ad-1
  Ad1: () => import('./Ad-1/web'),
  // Ad-2
  Ad2: () => import('./Ad-2/web'),
  // Ad-3
  Ad3: () => import('./Ad-3/web'),
  // Ad-4
  Ad4: () => import('./Ad-4/web'),
  // Ad-5
  Ad5: () => import('./Ad-5/web'),
  // Ad-6
  Ad6: () => import('./Ad-6/web'),
  // Ad-7
  Ad7: () => import('./Ad-7/web'),
  // Ad-8
  Ad8: () => import('./Ad-8/web'),
  // Ad-9
  Ad9: () => import('./Ad-9/web'),
  // Ad-10
  Ad10: () => import('./Ad-10/web'),
  // Achievement
  Achievement: () => import('./Achievement/web'),
  // Ad-11
  Ad11: () => import('./Ad-11/web'),
  // 自定义表单组件
  CustomerForm: () => import('./CustomerForm/web'),
  // 自定义按钮组件
  CustomButton: () => import('./CustomButton/web'),
  // 通用图片组件
  ImageList: () => import('./ImageList/web'),
  // 带标题通用图片组件（通用图片组件2)
  generalImgTwo: () => import('./generalImgTwo/web'),
  // 大图评价组件
  UserCommentsBigPicture: () => import('./UserCommentsBigPicture/web'),
  // FAQ文本样式组件
  Faqs: () => import('./Faqs/web'),
  // FAQ文本样式组件2
  Faqs2: () => import('./Faqs2/web'),
  // 富文本分栏组件 左右二分栏文本样式组件
  RichTextColumn: () => import('./RichTextColumn/web'),
  // 资料组件
  resourcesColumn: () => import('./Resource/web'),
  // 班级栏目组件
  ClassColumn: () => import('./ClassColumn/web'),
  // 课程栏目(一)组件
  CoursesColumn1: () => import('./CoursesColumn-1/web'),
  // 课程栏目(二)组件
  CoursesColumn2: () => import('./CoursesColumn-2/web'),
  // 课程详情栏目组件
  CoursesDetailColumn: () => import('./CoursesDetailColumn/web'),
  // 录播课组件
  RecordedGoodsColumn: () => import('./RecordedGoodsColumn/web'),
  // 通用商品组件
  CommonGoodsColumn: () => import('./CommonGoodsColumn/web'),
  // 数字滚动组件
  NumberScroll: () => import('./NumberScroll/web'),
  // 诊断入口组件
  EvaluationEntry: () => import('./EvaluationEntry/web'),
  // 图文组件：地图组件
  Map: () => import('./Map/web'),
  // 动态组件
  Dynamic: () => import('./Dynamic/web'),
  // Trustpilot评分组件
  Trustpilot: () => import('./Trustpilot/web'),
  // tmc 查分组件
  ScoreQueryComponent: () => import('./ScoreQueryComponent/web'),
  // 营销位组件
  MarketComponents: () => import('./MarketComponents/web'),
  // 主banner组件
  MainBanner: () => import(/* webpackPrefetch: true */ './MainBanner/web'),
  // 合作商家组件
  Partners: () => import(/* webpackPrefetch: true */ './Partners/web'),
  // 课程介绍
  CourseIntroduce: () => import('./CourseIntroduce/web'),

  // Ad-12
  Ad12: () => import('./Ad-12/web'),
  Ad13: () => import('./Ad-13/web'),
  Ad14: () => import('./Ad-14/web'),

  CourseIntroduce2: () => import('./CourseIntroduce-2/web'),
  CompetitorComparison: () => import('./CompetitorComparison/web'),
  VideoComponent: () => import('./VideoComponent/web'),
  VideoComponent2: () => import('./VideoComponent2/web'),
  // header image new
  HeaderImageNew: () => import('./HeaderImageNew/web'),
  // header image v2
  HeaderImageV2: () => import('./HeaderImageV2/web'),
  // carousel image new
  CarouselImageNew: () => import('./CarouselImageNew/web'),
  // data image new
  DataImageNew: () => import('./DataImageNew/web'),
  // teacher display new
  TeacherDisplayNew: () => import('./TeacherDisplayNew/web'),
  // review new
  ReviewNew: () => import('./ReviewNew/web'),
  // new achievement
  NewAchievement: () => import('./NewAchievement/web'),
  // TeachingPoint
  TeachingPointIntroduce: () => import('./TeachingPointIntroduce/web'),
  // programs carousel
  CarouselComponent1: () => import('./CarouselComponent1/web'),
  // carousel component 2
  CarouselComponent2: () => import('./CarouselComponent2/web'),
  // new main banner
  NewMainBanner: () => import('./NewMainBanner/web'),
  // joblistening
  JobListening: () => import('./JobListening/web'),
  // slider
  Slider: () => import('./Slider/web'),
  // 通用图片（贯穿图）
  GeneralImageFullWidth: () => import('./GeneralImageFullWidth/web'),
  // 步骤组件3
  StepComponent3: () => import('./StepComponent3/web'),
  // 步骤组件2 - Learning Journey
  StepComponent2: () => import('./StepComponent2/web'),
  // 学练课栏目组件
  PracticeCourseColumn: () => import('./PracticeCourseColumn/web'),
  // 弹窗组件
  Popup: () => import('./Popup/web'),
}

export default {
  name: 'DynamicComponent',
  mixins: [mixin],
  // data() {
  //   return {
  //     revealObserver: null,
  //   }
  // },
  // watch: {
  //   // 当渲染列表变更（例如 Category 加载后追加模块）时，重新为新增模块建立观察
  //   renderComponentList() {
  //     this.$nextTick(() => {
  //       this.observeAllWrappers()
  //     })
  //   },
  // },
  // mounted() {
  //   this.$nextTick(() => {
  //     // this.initRevealObserver()
  //     // this.observeAllWrappers()
  //   })
  // },
  // beforeDestroy() {
  //   if (this.revealObserver) {
  //     this.revealObserver.disconnect()
  //     this.revealObserver = null
  //   }
  // },
  methods: {
    getComponent(componentName) {
      return componentMap[componentName] || null;
    },
    initRevealObserver() {
      if (this.revealObserver || process.server) return
      if (!('IntersectionObserver' in window)) {
        // 兼容降级：直接展示
        const nodes = this.$el.querySelectorAll('.component-wrapper.reveal-section')
        nodes.forEach((el) => el.classList.add('is-visible'))
        return
      }
      this.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target
            el.classList.add('is-visible')
            // 元素只触发一次动画，随后取消观察
            this.revealObserver && this.revealObserver.unobserve(el)
          }
        })
      }, {
        root: null,
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      })
    },
    observeAllWrappers() {
      if (process.server) return
      const nodes = this.$el.querySelectorAll('.component-wrapper.reveal-section')
      nodes.forEach((el) => {
        if (!el.classList.contains('is-visible')) {
          // 为每个模块增加轻微的阶梯延迟
          const idx = Number(el.getAttribute('data-idx') || 0)
          const delay = Math.min(idx * 80, 240)
          el.style && el.style.setProperty('transition-delay', `${delay}ms`)
          this.revealObserver && this.revealObserver.observe(el)
        }
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.component-wrapper {
  // 使用内容可见性与内在尺寸占位，减少组件进入视口前的布局抖动
  // content-visibility: auto;
  // contain-intrinsic-size: 800px;
  margin-bottom: 60px;

  &.CourseIntroduce {
    margin-bottom: 0;
  }

  &:last-child {
    margin-top: 0;
  }

  &.special-wraper {
    margin-bottom: 0;
  }
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

// 滚动进入视口的上滑显隐动效
// .component-wrapper.reveal-section {
//   opacity: 0;
//   transform: translate3d(0, 20px, 0);
//   transition: opacity 0.6s ease, transform 0.6s ease;
//   will-change: opacity, transform;
// }
// .component-wrapper.reveal-section.is-visible {
//   opacity: 1;
//   transform: none;
// }

@media (max-width: 768px) {
  .component-wrapper {
    // 移动端组件普遍更高，提高占位高度
    contain-intrinsic-size: 1000px;

    &.Ad11 {
      padding-top: 9.333vw;
      padding-bottom: 13.067vw;
    }

    &.Faqs2 {
      margin-top: 0;
    }
  }
}

// Category 组件通常内含更多动态模块，占位更大以降低 CLS
.component-wrapper.Category {
  contain-intrinsic-size: 1100px;
}

@media (max-width: 768px) {
  .component-wrapper.Category {
    contain-intrinsic-size: 1400px;
  }
}
</style>
